import { Injectable } from '@angular/core';
import { SessionAwareMultiStore } from '../../../../shared/stores/session-aware-store';
import { Distributor } from '../models/distributor';

@Injectable({ providedIn: 'root' })
export class DistributorsStore extends SessionAwareMultiStore<Distributor> {}
